import { Helmet } from 'react-helmet-async'

type ContentLayoutProps = {
  title: string
  children: React.ReactNode
}

export const ContentLayout = ({ children, title }: ContentLayoutProps) => {
  return (
    <>
      <Helmet title={title} />
      <div className="flex min-w-full max-w-[1440px] items-center justify-center">
        {children}
      </div>
    </>
  )
}
